import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Jumps to the top on route changes, or to the #hash target once it has rendered.
const ScrollManager = () => {
  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      return undefined;
    }
    let frame;
    let attempts = 0;
    const scrollToHash = () => {
      const el = document.getElementById(decodeURIComponent(hash.slice(1)));
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else if (attempts < 30) {
        attempts += 1;
        frame = requestAnimationFrame(scrollToHash);
      }
    };
    scrollToHash();
    return () => cancelAnimationFrame(frame);
  }, [pathname, hash, key]);

  return null;
};

export default ScrollManager;
